import {
    Image,
    Stack,
    Center,
    Box,
    Heading,
    Text,
    Button,
} from "@chakra-ui/react";
import React from "react";
import {Link} from "react-router-dom"

const PaymentPage = () => {
    return (
        <div>
            <Stack>
                <br />
                <br />
                <br />
                <Center>
                    <Image
                        objectFit="cover"
                        height="215"
                        width="250"
                        src="https://www.rentomojo.com/public/images/error/no-cart.png"
                        alt="Cart is Empty"
                    />
                </Center>
            </Stack>
            <br />
            <Stack>
                <Box>
                    <Heading as="h3" size="lg"></Heading>
                    <Text fontSize="3xl">No items in cart</Text>
                </Box>

                <Box>
                    <Text>
                        Add a few items to your cart and come back here for an
                        <br />
                        express checkout process!
                    </Text>
                </Box>
                <br />
                <Box>
                    <Button borderRadius={0} bg="#dc3226" br="2px" color="white" variant="solid">
                        {/* <a href="/bangalore/catalog">Browse catalogue</a> */}
                        <Link to="/">
                        <Text px={2} py={2} as='abbr' fontSize='sm'>Browse catalogue</Text>

                        </Link>
                    </Button>
                </Box>
            </Stack>
        </div>
    );
};

export default PaymentPage;
